import naja from 'naja';

export default class Flashes {

    static init() {

        const hideModal = () => {
            const modal = document.getElementById('notification-modal');

            window.setTimeout(function() {
                modal.classList.add('modal--flash-hiding');
            }, 6000);
            window.setTimeout(function() {
                modal.style.display='none';
                modal.classList.remove('modal--flash-hiding');
            }, 6250);
        }

        hideModal();

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet--ajaxNotification') {
                hideModal();
            }
        });
    }
}
